import React, { useEffect, useRef, useState } from 'react'
import Layout from '../Layout'
import ReactHtmlParser from 'react-html-parser'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'
import { ThemeConstant } from '../../../utils/ThemeConstants'
export default function howItWorks(props) {
    const videoRef = useRef(null)
    const [showBigPlay, setShowBigPlay] = useState(true)
    useEffect(() => {
        const video = videoRef.current
        if (!video) return

        const handlePlay = () => setShowBigPlay(false)
        const handlePause = () => setShowBigPlay(true)
        const handleEnded = () => setShowBigPlay(true)

        video.addEventListener('play', handlePlay)
        video.addEventListener('pause', handlePause)
        video.addEventListener('ended', handleEnded)

        return () => {
            video.removeEventListener('play', handlePlay)
            video.removeEventListener('pause', handlePause)
            video.removeEventListener('ended', handleEnded)
        }
    }, [])
    const handleBigPlayClick = (e) => {
        e.stopPropagation()
        videoRef.current?.play()
    }
    return (
        <>
            <SEOTAG page="How it Works" />
            <Layout props={props}>
                {ThemeConstant?.isBuyBestProject ? (
                    <section className="how_it_works_buy py-4">
                        <div className="customContainer">
                            <div className="info-section">
                                <div className="info-text">
                                    <h2 className="section-title">How It Works</h2>
                                    <p className="section-subtitle">
                                        How Our Process Works <br /> Step-by-Step Guide
                                    </p>
                                    <div className="benefits">
                                        <div className="benefit-card">
                                            <h4>Browse & Bid</h4>
                                            <p>
                                                Explore our online auctions and place bids on any
                                                items you like. Each auction shows photos, product
                                                details, and condition notes.
                                            </p>
                                        </div>
                                        <div className="benefit-card">
                                            <h4>Win the Auction</h4>
                                            <p>
                                                If your bid is the highest when the auction ends,
                                                congratulations, the item is yours! You’ll receive
                                                an automatic confirmation with pickup instructions.
                                            </p>
                                        </div>
                                        <div className="benefit-card">
                                            <h4>Receive Pickup Notification</h4>
                                            <p>
                                                Once we prepare your order, you’ll get a
                                                notification letting you know your items are ready
                                                for pickup.
                                            </p>
                                        </div>
                                        <div className="benefit-card">
                                            <h4>Pick Up Your Items</h4>
                                            <p>
                                                Schedule your pickup time. Come to our pickup
                                                location, show your order confirmation, and collect
                                                your items. It’s that simple.
                                            </p>
                                        </div>
                                        <div className="benefit-card">
                                            <h4> Enjoy the Savings!</h4>
                                            <p>
                                                Every item you win is a great deal, whether it’s
                                                new, open-box, or returned retail merchandise.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="info-video">
                                    <video
                                        ref={videoRef}
                                        controls
                                        poster="/assets/images/BBL/thumbnail.jpeg"
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'contain',
                                            background: '#000',
                                            display: 'block',
                                        }}
                                        preload="metadata"
                                        playsInline
                                    >
                                        <source
                                            src={
                                                ThemeConstant?.isBuyBestProject
                                                    ? '/assets/video/buyBest4LessHowItWork.mp4'
                                                    : '/assets/video/demoPrimebids.mp4'
                                            }
                                            type="video/mp4"
                                        />
                                    </video>

                                    {showBigPlay && (
                                        <div
                                            onClick={handleBigPlayClick}
                                            style={{
                                                position: 'absolute',
                                                inset: 0,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                                background: 'rgba(0,0,0,0.25)',
                                                zIndex: 10,
                                                borderRadius: '18px',
                                                transition: 'background 0.3s',
                                            }}
                                            onMouseEnter={(e) =>
                                                (e.currentTarget.style.background =
                                                    'rgba(0,0,0,0.4)')
                                            }
                                            onMouseLeave={(e) =>
                                                (e.currentTarget.style.background =
                                                    'rgba(0,0,0,0.25)')
                                            }
                                        >
                                            <div
                                                style={{
                                                    width: 120,
                                                    height: 120,
                                                    borderRadius: '50%',
                                                    background: 'rgba(255,255,255,0.97)',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    boxShadow: '0 15px 40px rgba(0,0,0,0.6)',
                                                    transition: 'transform 0.2s',
                                                }}
                                                onMouseDown={(e) =>
                                                    (e.currentTarget.style.transform =
                                                        'scale(0.92)')
                                                }
                                                onMouseUp={(e) =>
                                                    (e.currentTarget.style.transform = 'scale(1)')
                                                }
                                            >
                                                <span
                                                    style={{
                                                        fontSize: 64,
                                                        marginLeft: 10,
                                                    }}
                                                >
                                                    ▶
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>
                ) : (
                    <div className="px-5 py-4 stctPgWrpr">
                        <span>{ReactHtmlParser(global.storeDetails.how_it_work)}</span>
                    </div>
                )}
            </Layout>
        </>
    )
}
